import { EventStatus } from '../../componentsV2/lvc-card/lvc-event-status'
import Minze, { EventListeners, MinzeElement, Reactive } from 'minze'
import Swiper from 'swiper'
import styles from 'swiper/swiper-bundle.min.css?inline'
import { renderDateElement, renderTicketButton } from '../../componentsV2/lvc-card/utils'
import { config, Font } from '../../constants'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'
import { decodeSlides } from '../../modules/sliderUtils'
import { getCardPlaceholder } from '../../modules/utils'
export interface LvcPrimarySlider {
  dataSlides: string
  zoomingEffectDisabled: boolean
  fadeEffect: boolean
  dataDescriptionBanner: string
  itemsPerSlide: number
  listName?: string
  dataComponentLocation: string
}

Locale.getInstance().registerKeySet('fr', 'primarySlider', {
  more: 'Voir plus...',
})

Locale.getInstance().registerKeySet('en', 'primarySlider', {
  more: 'See more...',
})

export class LvcPrimarySlider extends MinzeElement {
  attrs = [
    'data-slides',
    'zooming-effect-disabled',
    'fade-effect',
    'data-description-banner',
    'items-per-slide',
    'list-name',
    'data-layout',
    'data-component-location',
  ]
  reactive: Reactive = [['isMobile', window.matchMedia('(max-width: 730px)').matches]]
  _authHandler: any = null
  splitSlides<T>(arr: T[]): T[][] {
    const itemsPerSlide: number = this.isMobile ? 1 : parseInt(this.itemsPerSlide?.toString()) || 2
    if (arr?.length <= itemsPerSlide) return [[...arr]]
    const result: T[][] = []
    for (let i = 0; i < arr?.length || 0; i += itemsPerSlide) {
      const pair: T[] = []
      for (let y = 0; y < itemsPerSlide; y++) if (arr[i + y]) pair.push(arr[i + y])
      result.push(pair)
    }
    return result
  }
  handleWindowResize = () => {
    this.isMobile = window.matchMedia('(max-width: 730px)').matches
  }
  onLinkClicked = (event: Event) => {
    event.preventDefault()

    let el = event?.target as HTMLElement
    if (!el) return

    if (
      el.tagName !== 'LVC-FAVORITE-BUTTON' &&
      el.tagName !== 'LVC-TAGS' &&
      el.tagName !== 'LVC-FAVORITE-ICON-BUTTON'
    ) {
      const linkEl = el.closest('a')
      if (!linkEl) return
      if (
        linkEl.getAttribute('data-type') !== 'artist' &&
        linkEl.getAttribute('data-type') !== 'places'
      ) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'select_item',
          ecommerce: {
            items: [
              {
                item_id: linkEl.getAttribute('data-gtm-id') || '',
                item_name: linkEl.getAttribute('data-gtm-name') || '',
                item_brand: linkEl.getAttribute('data-gtm-brand') || '',
                item_category: linkEl.getAttribute('data-gtm-category') || '',
                item_category2: linkEl.getAttribute('data-gtm-category2') || '',
                item_category3: linkEl.getAttribute('data-gtm-category3') || '',
                item_category4: linkEl.getAttribute('data-gtm-category4') || '',
                item_list_name: this.listName || '',
                index: linkEl.getAttribute('data-gtm-index') ?? '',
              },
            ],
          },
        })
      }
      MainModule.getInstance().storeEventClickedFromList({
        listName: this.listName || '',
        index: linkEl.getAttribute('data-gtm-index') || '',
      })
      window.location.href = linkEl.getAttribute('href') || ''
    }
  }

  onReady(): void | Promise<void> {
    // NOT SURE WE NEED THIS...
    // const mainModule = MainModule.getInstance()
    // this._authHandler = this.handleAuthChanged.bind(this)
    // mainModule.getEE().on('lvc:user_logged_out', this._authHandler.bind(this))
  }

  // handleAuthChanged = async (): Promise<void> => {
  //   this.rerender()
  // }

  onRender() {
    this.setSliderArrowsSize()
    const swiperContainer = this.shadowRoot?.querySelector('.events_swiper') as HTMLElement
    const nextButton = this.shadowRoot?.querySelector('.swiper-next-wrapper') as HTMLElement
    const prevButton = this.shadowRoot?.querySelector('.swiper-prev-wrapper') as HTMLElement
    if (swiperContainer) {
      const swiper = new Swiper(swiperContainer, {
        speed: 400,
        spaceBetween:
          this.zoomingEffectDisabled || window.matchMedia('(max-width: 730px)').matches ? '7%' : 0,
        edgeSwipeDetection: true,
        mousewheel: true,
        touchEventsTarget: 'container',
        observer: true,
        observeParents: true,
        parallax: true,
        updateOnWindowResize: true,
        // Enable Navigation arrows
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
      })
      swiper.on('beforeResize', () => {
        swiper.params.spaceBetween =
          this.zoomingEffectDisabled || window.matchMedia('(max-width: 730px)').matches ? '7%' : 0
      })
    }
  }

  language = Locale.language

  viewMore(event: Event) {
    const slide = (event.target as Element)?.closest(
      '.events_slider-slide-content-block'
    ) as Element | null
    if (!slide) return
    const eventName = slide.getAttribute('data-event-name')
    if (!eventName) return
    Minze.cast(eventName)
  }

  setSliderArrowsSize() {
    const isDesktop = !window.matchMedia('(max-width: 730px)').matches

    const nextButton = this.shadowRoot?.querySelector('.slider-left-arrow') as HTMLElement
    const prevButton = this.shadowRoot?.querySelector('.slider-right-arrow') as HTMLElement
    if (nextButton && prevButton) {
      if (isDesktop) {
        nextButton.setAttribute('width', '56')
        nextButton.setAttribute('height', '56')
        prevButton.setAttribute('width', '56')
        prevButton.setAttribute('height', '56')
      } else {
        nextButton.setAttribute('width', '40')
        nextButton.setAttribute('height', '40')
        prevButton.setAttribute('width', '40')
        prevButton.setAttribute('height', '40')
      }
    }
  }

  renderPair(item: any) {
    if (item.seeMoreSlide) {
      return `
        <div class="events_slider-slide-content-block view-more-slide" data-event-name="${item.event}">
          <div class="events_slider-slide-image-wrapper">
            <lvc-image></lvc-image>
            <lvc-search-alternative-icon/>
          </div>
          <div class="events_slider-slide-text-wrapper">
            <div class="events_slider-slide-heading">
              <h2 class="events_slider-slide-title text-style-2lines">
                ${Locale.getKey('primarySlider.more')}
              </h2>
            </div>
          </div>
        </div>
      `
    }
    return /*html*/ `
      <lvc-card href="${item?.urlConstruct?.[Locale.language]}" class="events_slider-slide-content-block">
        ${item.status ? `<lvc-event-status slot="status" status="${item.status}"></lvc-event-status>` : ''}
        <lvc-image slot="image" src="${item?.cardImage || getCardPlaceholder(item?.schema as string)}" data-image-placeholder="${getCardPlaceholder(item?.schema as string)}"></lvc-image>
        ${
          item.festivals
            ? /*html*/ `
          <img
            src="https://cloud.squidex.io/api/assets/lvc-dev/52d936d4-b4dd-41e2-a763-e6c39cccc98f/lavitrine-ico-ne-festival-1-.png"
            slot="festival-icon"
          />
        `
            : ''
        }
        ${
          item.status !== EventStatus.Cancelled
            ? `
        <lvc-favorite-icon-button
          slot="favorite"
          data-id="${item?.id || ''}"
          data-type="${item?.schema || ''}" 
          data-gtm-name="${item?.name?.[Locale.language] || ''}"
          data-gtm-brand="${item?.artist?.[Locale.language] || ''}"
          data-gtm-category="${Array.isArray(item?.uiAdditionalTypes) ? item.uiAdditionalTypes.map((type: any) => type.code).join(', ') : ''}"
          data-gtm-category2="${item?.location?.[Locale.language] || ''}"
          data-gtm-category3="${item?.formattedDateTime || ''}"
          data-gtm-category4="${item?.isAccessibleForFree ? 'Gratuit' : 'Billet'}"
        >
        </lvc-favorite-icon-button>
        `
            : ''
        }
        <div slot="title">${item?.name?.[Locale.language]}</div>
        ${item?.festivals ? `<lvc-event-festival-badge slot="festival" label="${item?.festivals?.[0]?.nameFr}"></lvc-event-festival-badge>` : ''}
        ${renderDateElement(item, item?.status, item?.previousStartDate)}
        ${item?.location?.[Locale.language] && `<lvc-event-location slot="location" text="${[item?.location?.[Locale.language], item?.city?.[Locale.language]].filter(Boolean).join(', ')}"></lvc-event-location>`}
        ${renderTicketButton(item, this.dataComponentLocation)}
        <lvc-tags slot="tag" data-discipline-tags="${encodeURIComponent(JSON.stringify(item.uiAdditionalTypes))}"></lvc-tags>
      </lvc-card>
    `
  }

  html = () => `
     <div class="events_slider-component">
      <div class="swiper-prev-wrapper">
        <div class="swiper-prev"><lvc-slider-arrow-left-icon width="56" height="56" class="slider-left-arrow"></lvc-slider-arrow-left-icon></div>
      </div>
      <div class="swiper-next-wrapper">
        <div class="swiper-next"><lvc-slider-arrow-right-icon width="56" height="56" class="slider-right-arrow"></lvc-slider-arrow-right-icon></div>
      </div>
      <div class="events_swiper">
        <div class="swiper-wrapper">
          ${
            this.dataDescriptionBanner
              ? `
            <div class="swiper-slide">
              <img src="${this.dataDescriptionBanner}" class="events_slider-slide-content-block is-description-banner"/>
            </div>
            `
              : ''
          }
            ${this.splitSlides(decodeSlides(this.dataSlides))
              .map(
                (pair: any[]) => `
            <div class="swiper-slide">
              <div class="events_slider-slide-layout">
                ${pair.map(item => this.renderPair(item)).join('')}
              </div>
            </div>
          `
              )
              .join('')}
        </div>
      </div>
    </div>
  `

  css = () => `
    :host {
      color: #1e007d;
    }
    ${styles}
    a {
      text-decoration: none;
      color: inherit;
    }

    .events_slider-component {
      position: relative;
    }
    .swiper-prev:active, .swiper-next:active{
        -webkit-tap-highlight-color: transparent;
      }

    .swiper-prev {
      width: 56px;
      height: 56px;
      right: 0;
      border-radius: 100%;
      background-color: #fff;
      cursor: pointer;
      display: flex;
      justify-content: center;
      transition: transform 0.2s ease-in-out;
    }

    .swiper-next-wrapper {
      position: absolute;
      width: fit-content;
      z-index: 2;
      right: calc(-63px - 56px);
      top: 72px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .swiper-prev-wrapper {
      position: absolute;
      width: fit-content;
      z-index: 2;
      left: calc(-63px - 56px);
      top: 72px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .swiper-button-disabled {
      display: none;
    }
    
    .swiper-next {
      width: 56px;
      height: 56px;
      border-radius: 100%;
      background-color: #fff;
      cursor: pointer;
      display: flex;
      justify-content: center;
      transition: transform 0.2s ease-in-out;
    }


    .swiper-prev:hover,
    .swiper-next:hover {
      transform: scale(1.1);
    }

    .events_slider-slide-layout {
      grid-column-gap: 5%;
      align-items: flex-start;
      margin: ${
        this.zoomingEffectDisabled || window.matchMedia('(max-width: 730px)').matches
          ? '0'
          : '0 -10% -6% -10%'
      };
      display: flex;
      transition: all .2s;
    }
    .swiper-slide-active .events_slider-slide-layout {
      margin: 0;
    }
    .events_slider-slide-content-block {
      width: ${this.itemsPerSlide === 3 || this.itemsPerSlide?.toString() === '3' ? 30 : 50}%;
      flex: 0 auto;
      transition: all .2s;
    }
    .events_slider-slide-content-block.is-description-banner {
      width: 100%;
      height: auto;
    }
    .view-more-slide {
      cursor: pointer;
    }
    .events_slider-slide-image-wrapper {
      width: 100%;
    }
    .events_slider-slide-text-wrapper {
      transition: all .2s;
    }
    .events_slider-slide-heading {
      margin: 1.5rem 0 0 0;
    }
    .events_slider-slide-title {
      text-transform: uppercase;
      font-size: 1.5rem;
      margin-top: 0;
      margin-bottom: 0;
      font-weight: ${Font.weight.extraBold};
      line-height: 1.2;
    }
    .events_slider-slide-author {
      margin: 0.5rem 0 0 0;
    }
    .events_slider-slide-small-text {
      font-size: 14px;
    }
    .events_slider-slide-subtitle {
      font-size: 1.25rem;
      line-height: 1.8;
    }
    .events_slider-slide-info-wrapper {
      margin: 8px 0 16px 0;
      display: flex;
      flex-direction: column;
      row-gap: 6px;
    }
    .events_slider-slide-info-item {
      display: flex;
      grid-column-gap: 0.5rem;
      grid-row-gap: 0.5rem;
      align-items: center;
    }
    .events_slider-slide-info-icon {
      width: 24px;
      height: 24px;
      max-width: 100%;
      display: inline-block;
    }
    .events_slider-slide-button-wrapper {
      margin-top: 1.75rem;
    }
    .swiper-scrollbar-drag {
      background-color: #1E007D !important;
      height: 5px !important;
    }
    .swiper-scrollbar-horizontal{
      width: 418px !important;
      margin: auto !important;
      margin-top: 3.75rem !important;
      position: static !important;
      height: 5px !important;
      background-color: #FFFFFF !important;
      bottom: 0 !important;
    }
    .events_swiper {
      z-index: 0 !important;
    }
    .events_swiper-scrollbar {
      margin-top: 3.75rem !important;
    }
    .event-status-flag {
      background-image: url(${config.images.eventStatusLabelMask});
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: cover;
      background-attachment: scroll;
      padding: 4px 8px;
      font-size: 12px;
      line-height: 19px;
      position: absolute;
      top: -14px;
      bottom: auto;
      left: -8px;
      right: auto;
      z-index: 1;
    }
    .text-style-2lines {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .events_slider-slide-image-wrapper {
      position: relative;
    }
    ${
      this.zoomingEffectDisabled || window.matchMedia('(max-width: 730px)').matches
        ? `
        .swiper-slide-prev, .swiper-slide-next {
          margin: 0;
        }
      `
        : `
        .swiper-slide:not(.swiper-slide-active) {
          transform: translate(0, -12%) scale(0.75) !important;
          transition: all 0.5s ease !important;
        }
      `
    }
    .swiper-slide{
      transition: all 0.5s ease !important;
    }
    ${
      this.fadeEffect && !window.matchMedia('(max-width: 730px)').matches
        ? `
      .swiper-slide:not(.swiper-slide-active) {
        opacity: 0.4;
      }
    `
        : ``
    }
    .swiper-slide-next > .events_slider-slide-layout > .events_slider-slide-content-block > .events_slider-slide-text-wrapper {
      opacity:0 !important;
    }
    .swiper-slide-prev > .events_slider-slide-layout > .events_slider-slide-content-block > .events_slider-slide-text-wrapper {
      opacity:0 !important;
    }
    .swiper-slide-active > .events_slider-slide-layout > .events_slider-slide-content-block:hover {
      transform: scale(1.05);
    }
    @media only screen and (max-width: 730px) {
      .events_swiper {
        width: 92%;
      }
      .swiper-slide-active > .events_slider-slide-layout > .events_slider-slide-content-block:hover {
        transform: none;
      }
      .events_slider-slide-title {
        font-size: 20px;
      }
      .events_slider-slide-small-text {
        font-size: 12px;
      }
      .events_slider-slide-info-wrapper {
        grid-column-gap: 4px;
      }
      .events_slider-slide-content-block {
        width: 100%;
      }
      .events_swiper-scrollbar {
        margin-top: 16px!important;
      }
      .swiper-scrollbar-horizontal {
        width: 100%!important;
      }
      .events_slider-slide-button-wrapper {
        margin-top: 15px;
      }
      .events_slider-slide-heading {
        margin-top: 12px;
      }
      .swiper-next-wrapper, .swiper-prev-wrapper {
        display: none;
      }
    }
    @media screen and (min-width: 960px) and (orientation: landscape) and (max-width: 1500px) {
      .swiper-prev-wrapper {
        left: calc(62px - 56px);
        top: 94px;
      }
      .swiper-next-wrapper {
        right: calc(62px - 56px);
        top: 94px;
      }
    }

    @media screen and (min-width: 760px) and (orientation: portrait) and (max-width: 900px) {
      .swiper-prev-wrapper {
        left: calc(62px - 56px);
        top: 36px;
      }
      .swiper-next-wrapper {
        right: calc(62px - 56px);
        top: 36px;
      }

    }
    lvc-search-alternative-icon {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    .cancelled-badge, .postponed-badge, .rescheduled-badge {
      background: #FF4600;
      position: absolute;
      top: -3px;
      left: -3px;
      z-index: 1;
      display: flex;
      align-items: center;
      padding: 8px;
      gap: 10px;
      border-radius: 4px;
      color: #14141E;
    }
    
    .postponed-badge {
      background: #FFB201;
    }
    
    .rescheduled-badge {
      background: #DCFFD7;
    }
    
    .cancelled-badge lvc-sad-charlie-face-icon {
      height: 21px;
    }
    
    .postponed-badge lvc-reported-icon {
      height: 24px;
    }
    
    .events_slider-slide-content-block.disabled >a >*:not(.cancelled-badge, .events_slider-slide-text-wrapper),
    .events_slider-slide-content-block.disabled .events_slider-slide-info-wrapper >*:not(.event-date),
    .events_slider-slide-content-block.disabled .events_slider-slide-heading,
    .events_slider-slide-content-block.disabled .event_similar-event-info-icon >*:not(.info-icon),
    .events_slider-slide-content-block.disabled .event-date-text {
      opacity: 0.5;
    }
    
    .events_slider-slide-content-block.disabled .event-date-text {
      text-decoration: line-through;
    }
    
    .event_similar-event-info-icon {
      position: relative;
      display: flex;
      align-items: center;
    }
    
    .info-icon {
      position: absolute;
      top: -5px;
      right: -5px;
    }
    
    .info-icon:hover .info-tooltip {
      display: block;
    }
    
    .info-tooltip {
      display: none;
      position: absolute;
      border: 1px solid #1E007D4D;
      background: white;
      border-radius: 8px;
      z-index: 1;
      padding: 16px;
      width: max-content;
    }
  `

  eventListeners: EventListeners = [
    ['a', 'click', this.onLinkClicked],
    ['.view-more-slide', 'click', this.viewMore.bind(this)],
    [window, 'resize', this.handleWindowResize],
  ]
}
